<template>
  <div class="home_box">
    <div class="en_box" v-if="$i18n.language == 'en'">
      <img src="../assets/images/business_en.jpg" alt="" />
    </div>
    <div class="business_page" v-else>
      <div class="banner">
        <img src="../assets/images/ywbj_banner.png" alt="" />
      </div>
      <div class="btn_box">
        <div class="btn_body">
          <div class="btns">
            <div
              class="btn"
              :class="tabIndex === item ? 'btn_act' : ''"
              v-for="(item, index) in btns"
              :key="index"
              @click="changeTab(item)"
            >
              {{ $t(item) }}
            </div>
          </div>
          <div class="goback">
            <span @click="goback()">{{ $t("common.goBack") }}</span> >
            <span> {{ $t("nav.business") }}</span>
          </div>
        </div>
      </div>
      <div class="xxyl_box" v-show="tabIndex === 'business.offlineMedical'">
        <img src="../assets/images/xxyl_title.png" alt="" />
        <div class="img_list">
          <div class="img">
            <img src="../assets/images/cqyy_img.png" alt="" />
            <div class="text_box">
              <div class="title1">{{ $t("business.communityHealth") }}</div>
              <div class="tips">{{ $t("business.communityHealth.desc") }}</div>
            </div>
          </div>
          <div class="img">
            <img src="../assets/images/kqyl_img.png" alt="" />
            <div class="text_box">
              <div class="title1">{{ $t("business.dental") }}</div>
              <div class="tips">{{ $t("business.dental.desc") }}</div>
            </div>
          </div>
          <div class="img">
            <img src="../assets/images/gyg_img.png" alt="" />
            <div class="text_box">
              <div class="title1">{{ $t("business.tcm") }}</div>
              <div class="tips">{{ $t("business.tcm.desc") }}</div>
            </div>
          </div>
          <div class="img">
            <img src="../assets/images/ck_img.png" alt="" />
            <div class="text_box">
              <div class="title1">{{ $t("business.postpartum") }}</div>
              <div class="tips">{{ $t("business.postpartum.desc") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="xsyl_box" v-show="tabIndex === 'business.onlineMedical'">
        <img src="../assets/images/xsyl_title.png" alt="" />
        <img src="../assets/images/xsyl_img.png" alt="" />
      </div>
      <div class="jykj_box" v-show="tabIndex === 'business.medicalTech'">
        <img src="../assets/images/jykj_title1.png" alt="" />
        <img src="../assets/images/jykj_img1.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "business",
  data() {
    return {
      tabIndex: "business.offlineMedical",
      btns: [
        "business.offlineMedical",
        "business.onlineMedical",
        "business.medicalTech",
      ],
    };
  },
  methods: {
    goback() {
      this.$router.push("/Home");
    },
    changeTab(item) {
      this.tabIndex = item;
    },
  },
};
</script>
<style lang="scss" scoped>
.home_box {
  width: 100%;
  height: 100%;
  .en_box {
    width: 100%;
    height: auto;
    margin-top: -110px;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.business_page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  .banner {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .btn_box {
    width: 100%;
    height: 64px;
    background-color: #f0f1f5;

    .btn_body {
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btns {
        width: 50%;
        height: 64px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .btn {
          width: auto;
          padding: 5px 10px;
          box-sizing: border-box;
          background-color: rgba(255, 255, 255, 1);
          margin-right: 15px;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
            transition: all 0.3s;
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
          }
        }

        .btn_act {
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
        }
      }

      .goback {
        width: auto;
        height: 64px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        span {
          cursor: pointer;

          &:last-child {
            font-weight: bold;
          }
        }
      }
    }
  }

  .xxyl_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }

    .img_list {
      width: 100%;
      max-width: 1400px;
      height: auto;
      margin: 0 auto;
      padding-top: 50px;
      padding-bottom: 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .img {
        width: 49%;
        height: 600px;
        margin-bottom: 2%;
        border-radius: 20px;
        overflow: hidden;
        position: relative;
        cursor: pointer;

        &:hover {
          .text_box {
            opacity: 1;
          }
        }

        img {
          width: 100%;
          height: auto;
        }

        .text_box {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0%;
          opacity: 0;
          transition: all 0.3s;
          padding: 30px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-direction: column;
          background-color: rgba(0, 0, 0, 0.3);
          color: rgba(255, 255, 255, 1);

          .title1 {
            width: 100%;
            font-size: 40px;
            font-weight: bold;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .tips {
            width: 100%;
            font-size: 20px;
            font-weight: bold;
            text-align: justify;
          }
        }
      }
    }
  }

  .xsyl_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .jykj_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>